import { render } from "./RecentActivity.vue?vue&type=template&id=7c0907cd&ts=true"
import script from "./RecentActivity.vue?vue&type=script&lang=ts"
export * from "./RecentActivity.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__